import $ from 'jquery'

//'use strict';

var wc_checkout_coupons = {
	init: function () {
		$(document.body).on('click', 'a.showcoupon', this.show_coupon_form);
		$(document.body).on('click', '.eaplus-remove-coupon', this.remove_coupon);
		$(document.body).on('click', 'button[name="eaplus_apply_coupon"]', this.submit);
	},
	show_coupon_form: function () {

		$('.checkout_coupon').slideToggle(400, function () {
			$('.checkout_coupon').find(':input:eq(0)').trigger('focus');
		});
		return false;
	},
	submit: function () {

		// wc_checkout_params is required to continue, ensure the object exists
		if (typeof wc_checkout_params === 'undefined') {
			return false;
		}

		var $form = $('form[name="checkout"]');
		if ($form.is('.processing')) {
			return false;
		}

		$form.addClass('processing').block({
			message: null,
			overlayCSS: {
				background: '#fff',
				opacity: 0.6
			}
		});

		var data = {
			security: wc_checkout_params.apply_coupon_nonce,
			coupon_code: $form.find('input[name="coupon_code"]').val()
		};

		$.ajax({
			type: 'POST',
			url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
			data: data,
			success: function (code) {
				$('.woocommerce-error, .woocommerce-message').remove();
				$form.removeClass('processing').unblock();

				if (code) {
					// $form.before(code);
					// $form.slideUp();
					$('div.coupon-form').after(code);

					$(document.body).trigger('applied_coupon_in_checkout', [data.coupon_code]);
					$(document.body).trigger('update_checkout', {
						update_shipping_method: false
					});
				}
			},
			dataType: 'html'
		});

		return false;
	},
	remove_coupon: function (e) {

		// wc_checkout_params is required to continue, ensure the object exists
		if (typeof wc_checkout_params === 'undefined') {
			return false;
		}

		e.preventDefault();
		var container = $(this).parents('.woocommerce-checkout-review-order'),
			coupon = $(this).data('coupon');

		container.addClass('processing').block({
			message: null,
			overlayCSS: {
				background: '#fff',
				opacity: 0.6
			}
		});

		var data = {
			security: wc_checkout_params.remove_coupon_nonce,
			coupon: coupon
		};

		$.ajax({
			type: 'POST',
			url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_coupon'),
			data: data,
			success: function (code) {
				$('.woocommerce-error, .woocommerce-message').remove();
				container.removeClass('processing').unblock();

				if (code) {
					//$('form.woocommerce-checkout').before(code);

					$('div.cart-discount').after(code);

					$(document.body).trigger('removed_coupon_in_checkout', [data.coupon]);
					$(document.body).trigger('update_checkout', {
						update_shipping_method: false
					});

					// Remove coupon code from coupon field
					$('form.checkout_coupon').find('input[name="coupon_code"]').val('');
				}
			},
			error: function (jqXHR) {
				if (wc_checkout_params.debug_mode) {
					/* jshint devel: true */
					console.log(jqXHR.responseText);
				}
			},
			dataType: 'html'
		});
	}
};

wc_checkout_coupons.init();

// Checkout validation
//Validate email
$('body').on('blur change', '#billing_email', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	//var pattern = new RegExp(/^.+@.{2,}\./);
	var pattern = new RegExp(/^(?=.{1,50}$).+@.{2,}\./);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
//Validate first name
$('body').on('blur change', '#billing_first_name', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	//var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
	var pattern = new RegExp(/^(?=.{1,14}$)[a-zA-Z \-\']*$/i);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
//Validate Middle Initial
$('body').on('blur change', '#billing_middle_initial', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	//var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
	var pattern = new RegExp(/^(?=.{0,1}$)[a-zA-Z]*$/i);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
//Validate last name
$('body').on('blur change', '#billing_last_name', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	//var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
	var pattern = new RegExp(/^(?=.{1,15}$)[a-zA-Z \-\']*$/i);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
//Validate billing address 1
$('body').on('blur change', '#billing_address_1', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	//var pattern = new RegExp(/^[^?]*$/);
	var pattern = new RegExp(/^(?=.{5,30}$)[^?]*$/);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
//Validate billing address 2
// $('body').on('blur change', '#billing_address_1', function() {
//   const wrapper = $(this).closest('.form-row');
//   // Regex pattern
//   //var pattern = new RegExp(/^[^?]*$/);
//   var pattern = new RegExp(/^(?=.{0,30}$)[^?]*$/);
//   // you do not have to removeClass() because Woo do it in checkout.js
//   if (!pattern.test($(this).val())) {
//     wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
//   } else {
//     wrapper.addClass('woocommerce-validated'); // success
//   }
// });
//Validate city
$('body').on('blur change', '#billing_city', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	//var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
	var pattern = new RegExp(/^(?=.{2,19}$)[a-zA-Z \-\']*$/i);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
//Validate state
$('body').on('blur change', '#billing_state', function () {
	const wrapper = $(this).closest('.form-row');
	// you do not have to removeClass() because Woo do it in checkout.js
	if ($(this).val() == 'NY') {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
// Validate Zip code
$('body').on('blur change', '#billing_postcode', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	var pattern = new RegExp(/^\d{5}(-\d{4})?$/);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
// Validate phone
$('body').on('blur change', '#billing_phone', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	var pattern = new RegExp(/^[0-9\-\.]{0,12}$/);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});

// VALIDATE HOME
//Validate billing address 1
$('body').on('blur change', '#home_street_address', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	//var pattern = new RegExp(/^[^?]*$/);
	var pattern = new RegExp(/^(?=.{5,30}$)[^?]*$/);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
//Validate city
$('body').on('blur change', '#home_city', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	//var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
	var pattern = new RegExp(/^(?=.{2,19}$)[a-zA-Z \-\']*$/i);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
//Validate state
$('body').on('blur change', '#home_state', function () {
	const wrapper = $(this).closest('.form-row');
	// you do not have to removeClass() because Woo do it in checkout.js
	if ($(this).val() == 'NY') {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});
// Validate Zip code
$('body').on('blur change', '#home_zip_code', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	var pattern = new RegExp(/^\d{5}(-\d{4})?$/);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});

// Validate phone
$('body').on('blur change', '.input-phone', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	var pattern = new RegExp(/^[0-9\-\.]{0,12}$/);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
		var val = $(this).val();
		if (val.length === 10) {
			$(this).val(phoneFormat(val));
		}
	}
});

// Validate IMEI
$('body').on('blur change', '.input-imei', function () {
	const wrapper = $(this).closest('.form-row');
	// Regex pattern
	var pattern = new RegExp(/^\d{15,17}$/);
	// you do not have to removeClass() because Woo do it in checkout.js
	if (!pattern.test($(this).val())) {
		wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
	} else {
		wrapper.addClass('woocommerce-validated'); // success
	}
});

const phoneFormat = (input) => {
	//if(!input || isNaN(input)) return `input must be a number was sent ${input}`
	if (typeof (input) !== 'string') input = input.toString()
	if (input.length === 10) {
		return input.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
	}
	// else if (input.length < 10) {
	// 	return 'was not supplied enough numbers please pass a 10 digit number'
	// } else if(input.length > 10) {
	// 	return 'was supplied too many numbers please pass a 10 digit number'
	// }else{
	// 	return 'something went wrong'
	// }
}

$(window).on('load', function () {
	required_or_optional(); //this calls it on load
	//$('#same_as_billing').change(required_or_optional);
	$('#same_as_billing').on('change', required_or_optional);

	function required_or_optional() {

		// get values from local storage
		let formValues = window.localStorage.getItem('dg_woo_form');
		if (formValues && JSON.parse(formValues)) {
			formValues = JSON.parse(formValues);
			if (formValues.hasOwnProperty('home_street_address')) {
				$('#same_as_billing').attr('checked', false);
				$('.home-collapse').each(function () {
					$(this).addClass('show');
				});
				$('label[for="same_as_billing"]').removeClass('collapsed');
				$('label[for="same_as_billing"]').attr('aria-expanded', 'true');
			} else {
				$('#same_as_billing').attr('checked', true);
				$('label[for="same_as_billing"]').addClass('collapsed');
				$('label[for="same_as_billing"]').attr('aria-expanded', 'false');
			}
		} else {
			$('#same_as_billing').attr('checked', true);
			$('label[for="same_as_billing"]').addClass('collapsed');
			$('label[for="same_as_billing"]').attr('aria-expanded', 'false');
		}

		if ($('#same_as_billing').is(':checked')) {
			// home_street_address
			$('#home_street_address').removeProp('required');
			$('#home_street_address').val('');
			$('label[for="home_street_address"] .required').remove();
			// Avoid append this multiple times
			if ($('label[for="home_street_address"] .optional').length == 0) {
				$('label[for="home_street_address"]').append('<span class="optional">(optional)</span>');
			}
			// home_zip_code
			$('#home_zip_code').removeProp('required');
			$('#home_zip_code').val('');
			$('label[for="home_zip_code"] .required').remove();
			// Avoid append this multiple times
			if ($('label[for="home_zip_code"] .optional').length == 0) {
				$('label[for="home_zip_code"]').append('<span class="optional">(optional)</span>');
			}
			// home_city
			$('#home_city').removeProp('required');
			$('#home_city').val('');
			$('label[for="home_city"] .required').remove();
			// Avoid append this multiple times
			if ($('label[for="home_city"] .optional').length == 0) {
				$('label[for="home_city"]').append('<span class="optional">(optional)</span>');
			}
			// home_state
			$('#home_state').removeProp('required');
			$('#home_state').val('AK');
			$('label[for="home_state"] .required').remove();
			// Avoid append this multiple times
			if ($('label[for="home_state"] .optional').length == 0) {
				$('label[for="home_state"]').append('<span class="optional">(optional)</span>');
			}

			$('label[for="same_as_billing"]').addClass('collapsed');
			$('label[for="same_as_billing"]').attr('aria-expanded', 'false');
			$('.home-collapse').each(function () {
				$(this).removeClass('show');
			});
		} else {
			// home_street_address
			$('#home_street_address').prop('required', true);
			$('label[for="home_street_address"] .optional').remove();
			//$('label[for="home_street_address"]').append('<abbr class="required" title="required">*</abbr>');
			if ($('label[for="home_street_address"] .required').length == 0) {
				$('label[for="home_street_address"]').append('<abbr class="required" title="required">*</abbr>');
			}
			// home_zip_code
			$('#home_zip_code').prop('required', true);
			$('label[for="home_zip_code"] .optional').remove();
			//$('label[for="home_zip_code"]').append('<abbr class="required" title="required">*</abbr>');
			if ($('label[for="home_zip_code"] .required').length == 0) {
				$('label[for="home_zip_code"]').append('<abbr class="required" title="required">*</abbr>');
			}
			// home_city
			$('#home_city').prop('required', true);
			$('label[for="home_city"] .optional').remove();
			//$('label[for="home_city"]').append('<abbr class="required" title="required">*</abbr>');
			if ($('label[for="home_city"] .required').length == 0) {
				$('label[for="home_city"]').append('<abbr class="required" title="required">*</abbr>');
			}
			// home_state
			$('#home_state').prop('required', true);
			$('label[for="home_state"] .optional').remove();
			//$('label[for="home_state"]').append('<abbr class="required" title="required">*</abbr>');
			if ($('label[for="home_state"] .required').length == 0) {
				$('label[for="home_state"]').append('<abbr class="required" title="required">*</abbr>');
			}
		}
	}
});

var dgWoo = {
	init: function () {
		$(window).on('load', this.checkStorage);
	},
	// first we autofill the form with saved values, if they exist
	checkStorage: function () {

		// get values from storage
		let formValues = window.localStorage.getItem('dg_woo_form');
		if (formValues && JSON.parse(formValues)) {
			formValues = JSON.parse(formValues);

			for (const name in formValues) {
				const value = formValues[name];
				if (value && name) {
					// loop over saved values and fill in the corresponding form input
					let $input = $('input[name=' + name + ']');
					if ($input.length) {
						// radio buttons are handled differently than other inputs
						if ($input.attr('type') === 'radio' || $input.attr('type') === 'checkbox') {
							$input.filter('[value="' + value + '"]').attr('checked', true);
						} else {
							$input.val(value);
						}

					}
				}

			}
		}

		// listen for new changes
		dgWoo.startListener();

	},
	startListener: function () {
		const $form = $('form.woocommerce-checkout');
		$form.change(event => {
			let wooForm = {};
			$('form.woocommerce-checkout :input').each(function () {

				if (!$(this)[0]) return;

				// don't save hidden or CC inputs
				if ($(this)[0].type === 'hidden' || $(this)[0].classList.contains('__PrivateStripeElement-input') || $(this)[0].autocomplete === 'cc-number') {
					return;
				}

				let name = ($(this)[0] ? $(this)[0].name : null);
				if (!name) return;

				let value = $(this).val();

				// radio buttons and checkboxes are handled differently
				if ($(this)[0].type === 'radio' || $(this)[0].type === 'checkbox') {

					if (!$(this).is(":checked")) {
						return;
					}
				}

				if (value) {
					wooForm[name] = value;
				}

			});

			// save all values to browser storage on each change
			window.localStorage.setItem('dg_woo_form', JSON.stringify(wooForm));
		});
	}
};
dgWoo.init();

jQuery(function () {
	$("#m-order-summary").on("click", function () {
		$("#order_review").toggleClass("visually-hidden-sm");
		var $this = $(this);
		if ($("#order_review").hasClass("visually-hidden-sm")) {
			$this.find(".summary").text("Show order summary");
			$this.find(".arrow-up").removeClass("arrow-up").addClass("arrow-down");
		} else {
			$this.find(".summary").text("Hide order summary");
			$this.find(".arrow-down").removeClass("arrow-down").addClass("arrow-up");
		}
	});
});